import { useMemo } from "react";
import { IAuditNote, TEditableAuditNote } from "../../interfaces/IAuditNote";
import { useAuditNoteContext } from "../../context/AuditNoteContext";

export type IUseNotesByFieldData = (fieldKey: IAuditNote["key"]) => {
    data: TEditableAuditNote[];
};

export const useNotesByField: IUseNotesByFieldData = (fieldKey: IAuditNote["key"]) => {
    const { notes } = useAuditNoteContext();
    const noteList = Object.keys(notes);

    const rawData = useMemo(() => {
        return noteList.reduce<TEditableAuditNote[]>((acc, id) => {
            let data = notes[id];

            if (data.key === fieldKey) {
                acc.push(data);
            }
            return acc
        }, []);
    }, [notes, noteList, fieldKey])

    return { data: rawData }
}